var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZijin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.346 5.3l1.636 1.636L9.62 5.3M5.8 7.482h4.363M5.8 9.664h4.363M7.982 6.937V11.3",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8a.5.5 0 00-1 0h1zm-13 0a.5.5 0 001 0h-1zm.513-.4l.499.033-.5-.033zm11.974.8l-.5-.033.5.033zm-1.22-3.145a.5.5 0 10.866-.5l-.866.5zM3.235 10.75a.5.5 0 10-.865.5l.865-.5zM2.5 8c0-.123.004-.246.012-.367l-.998-.066c-.01.143-.014.288-.014.433h1zm.012-.367A5.5 5.5 0 018 2.5v-1a6.5 6.5 0 00-6.486 6.067l.998.066zM13.5 8c0 .123-.004.246-.012.367l.998.066c.009-.143.014-.288.014-.433h-1zm-.012.367A5.5 5.5 0 018 13.5v1a6.5 6.5 0 006.486-6.067l-.998-.066zM8 2.5a5.498 5.498 0 014.767 2.755l.866-.5A6.498 6.498 0 008 1.5v1zm0 11a5.498 5.498 0 01-4.765-2.75l-.865.5A6.498 6.498 0 008 14.5v-1z",
    fill: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51 8.447h.98l-.49.49-.49-.49zM14.49 7.553h-.98l.49-.49.49.49z",
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zijin.9d5c9fba.svg";
export { SvgTongyongZijin as ReactComponent };